import React, { Component, lazy, Suspense } from "react";
import { withRouter } from "react-router-dom";

import {
  Page,
  Card,
  Layout,
  SkeletonBodyText,
  Button,
  Pagination,
  Toast,
  SkeletonPage,
  BlockStack,
  // Select,
  Link,
  Modal,
  // Text,
  Spinner,
  InlineStack,
  Box,
  Checkbox,
  Icon,
  Popover,
  // ActionList,
  // OptionList,
  Banner,
  SkeletonDisplayText,
  EmptyState,
  // Checkbox,Popover,ActionList,ExceptionList,Badge,Modal
} from "@shopify/polaris";
import {
  // TickMinor,
  // AddMajor,
  ChevronRightMinor,
  // ChevronLeftMinor,
  // SortMinor,
  UploadMajor,
  MinusMinor,
  SearchMajor
} from "@shopify/polaris-icons";
import utils from "../../../../utils/utils";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import AppBridge from "../../../../utils/appBridge";
import _ from "lodash";
import {
  reqGetFindProductListData,
  reqPostFindProductAdd,
  reqGetFindProductCateListData,
  reqPreference,
  reqGoogleAnalytics,
  reqGetCoupon,
  reqReceiveCoupon,
  reqFileMapSearch,
  reqGetUserSubcribe,
  getPostCateSelect,
  getGetProductAddSuccess,
} from "../../../../api";

import "../index.css";
import "./listItem.css";
import intl from "../../../../i18n/intl";
// import UserProductPreferences from "../../../../components/UserProductPreferences";
import moment from "moment";
import { store } from "../../../../store";
// import { connect} from "react-redux";
import ListItem from "./ListItem";
import CateTab from "./CateTab";
import CateClass from "./CateClass";
import ImportFormOther from "../../ImportList/components/ImportFormOther";
import ImportAliexpressModal from "../../SubscriptionPaid/components/ImportAliexpressModal";
import { changeBannerData, changePersonLevel } from "../../../../slice";
import { connect } from "react-redux";
// import CommonModalApp from "../../../../components/NoviceGuidance/CommonModalApp";
import LevelAction from "../../../../components/LevelAction";
const UpgradePlanModal = lazy(() =>
  import("../../SubscriptionPaid/components/UpgradePlanModal")
);
const ImportDsmModal = lazy(() =>
  import("../../SubscriptionPaid/components/ImportDsmModal")
);

class FindProducts extends Component {
  state = {
    //页面动作
    chargeError: false,
    loadingPage: true,
    isSearching: "0",
    page: 1,
    size: 80,
    pageValue: "",
    hasPrevious: false,
    hasNext: true,
    Imageload: false,
    ShowCountNumber: 0,
    total: 1,
    // 列表原始数据
    pageData: [],
    // DIV列表数据
    ListDivHtml: <div></div>,
    MenuId: "",
    Child: "",
    tabSelected: 0,
    queryValue: "", // 关键词内容搜索
    sortBy: "",
    PageCount: 0,
    CateValue: "",
    dataList: [],
    cateLists: [],
    currentCateList:[
      {
        category_name: "Bags & Shoes",
        category_id:39,
        select: 0,
      },
      {
        category_name: "Jewelry & Watches",
        category_id:70,
        select: 0,
      },
      {
        category_name: "Health, Beauty & Hair",
        category_id:108,
        select: 0,
      },
      {
        category_name: "Women's Clothing",
        category_id:152,
        select: 0,
      },
      {
        category_name: "Sports & Outdoors",
        category_id:192,
        select: 0,
      },
      {
        category_name: "Toys, Kids & Babies",
        category_id:356,
        select: 0,
      },
      {
        category_name: "Consumer Electronics",
        category_id:441,
        select: 0,
      },
    ],
    ProductsTitle: "",
    ProductsTitleInfo: "",
    showUserPreferences: false,
    CouponModal: false,
    CouponData: [],
    SeachImage: false,
    //checkChromePlugins: {}, // 接收公共数据中的chorme_plugins id和install_check分别表示谷歌插件ID和安装检查功能是否可用
    CheckGooglePluginActive: false, // 谷歌插件弹窗开关状态
    GooglePluginInstall: false, // 是否安装谷歌插件

    // 斋月节banner ramadan
    ramadanImage: "",
    upgradeModal: false, //升级付费弹窗
    importantLimit: 0, //商品导入限制
    importantDsmModal: false, //dsm产品导入限制
    importantDay: 3, //每天限定导入
    holidayData: {}, //节日商品数据
    holidayBanner: [], //节日轮播图
    isCate: false, // 是否显示选择偏好
    warningMessage: "",
    cateSelectData: [
      {
        label: "Computer & Office",
        value:1,
        select: 0,
      },
      {
        label: "Bags & Shoes",
        value:39,
        select: 0,
      },
      {
        label: "Jewelry & Watches",
        value:70,
        select: 0,
      },
      {
        label: "Health, Beauty & Hair",
        value:108,
        select: 0,
      },
      {
        label: "Women's Clothing",
        value:152,
        select: 0,
      },
      {
        label: "Sports & Outdoors",
        value:192,
        select: 0,
      },
      {
        label: "Home Improvement",
        value:279,
        select: 0,
      },
      
      {
        label: "Toys, Kids & Babies",
        value:356,
        select: 0,
      },
      {
        label: "Men's Clothing",
        value:397,
        select: 0,
      },
      {
        label: "Consumer Electronics",
        value:441,
        select: 0,
      },
      {
        label: "Phones & Accessories",
        value:483,
        select: 0,
      },
      {
        label: "Home, Garden & Furniture",
        value:235,
        select: 0,
      },
      {
        label: "Automobiles & Motorcycles",
        value:312,
        select: 0,
      },
    ],
    productAddSuccess: false, // 是否不再显示导入成功弹窗
    selectAgain: false, // 选择不再弹窗
    popoverSort: false,
    isSelectCate: false, // 是否选择类目
    categories: false, //是否显示类目
    priceRangeActive: false, //是否展示价格范围
    minPrice: "",
    maxPrice: "",
    currentMinPrice:'',
    currentMaxPrice:'',
    cateSelectTitle: "All Categories",
    breadcrumbs:{
      cateTitle:'Recommendation',
      id:'',
      bread2:{
        cateTitle:'',
        id:'',
        bread3:{
          cateTitle:'',
          id:'',
        }
      }
    },
    otherImportParams:{
      open:false,

    },
    importantAliLimit:0,
    aliImportModal:false,
    temuModal:false,//TM弹窗
    priceError:false,// 是否输入价格区间
    selectCateLoading:false, // 偏好选择按钮加载
  };

  //进入页面调用接口
  componentDidMount() {
    let params = new URLSearchParams(window.location.search);
    let linkPage = params.get("linkPage");
    let cateId  = params.get("cateId");
    let minPrice = params.get('minPrice');
    let maxPrice = params.get('maxPrice');
    window.onscroll = this.onScroll;
    window.onresize = this.onResize;
    this.onResize();
    document.documentElement.style.scrollBehavior = "smooth";
    if (AppBridge && AppBridge.exist()) {
      AppBridge.setTitleBar("Find Products");
    }
    setTimeout(() => {
      // this.getPreference()
      this.setState({
        page:linkPage ? linkPage : 1,
        CateValue:cateId ? Number(cateId) : "",
        minPrice:minPrice ? minPrice : '',
        maxPrice:maxPrice ? maxPrice : '',
        currentMinPrice:minPrice ? minPrice : '',
        currentMaxPrice:maxPrice ? maxPrice : '',
      },()=>{
        this.getPageData();
      });
      this.getMenu();
      this.getCounpon();
    }, 0);
  }

  componentWillUnmount() {
    window.onscroll = null;
    window.onresize = null;
  }

  // shouldComponentUpdate(nextProps, nextState) {
  // if (!_.isNil(nextProps.chromePlugins)) {
  //   if (Boolean(Object.keys(nextProps.chromePlugins).length)) {
  //     if (nextProps.chromePlugins !== this.state.checkChromePlugins) {
  //       this.setState({
  //         checkChromePlugins: nextProps.chromePlugins
  //       }, () => {
  //         if (Boolean(this.state.checkChromePlugins.install_check)) {
  //           this.checkGooglePlugin(this.state.checkChromePlugins.id);
  //         }
  //       })
  //     }
  //   }
  //   return true
  // }
  // return true
  // }

  onScroll = () => {
    let obj = document.getElementById("showTopButton");
    if (obj) {
      if (document.documentElement.scrollTop > 2250) {
        obj.style.display = "block";
      }
      if (document.documentElement.scrollTop < 2250) {
        obj.style.display = "none";
      }
    }
  };

  onResize = () => {
    if (document.body.clientWidth < 1024) {
      this.setState({
        ramadanImage: "/ramadan/banner_mobile.png",
      });
    } else {
      this.setState({
        ramadanImage: "/ramadan/banner.png",
      });
    }
  };

  handleClickRamadan = () => {
    const cateLists = _.cloneDeep(this.state.cateLists);
    const fn = (arr) => {
      _.forEach(arr, (item) => {
        if (!_.isArray(item.children_data)) {
          const list = [];
          _.forIn(item.children_data, (value) => {
            list.push(value);
          });
          item.children_data = list;
          fn(item.children_data);
        }
      });
    };
    fn(cateLists);
    const ramadan = this.filterCateList(cateLists, "Ramadan"); // Ramadan
    this.setState(
      {
        CateValue: ramadan.id || "",
        ProductsTitle: "All Categories ",
        ProductsTitleInfo: ">Holidays & Events>Ramadan",
        page: 1,
        queryValue: "",
      },
      () => {
        // 更新列表数据
        this.getPageData(true);
      }
    );
  };

  // 从类目中获取子节点
  filterCateList = (data, name) => {
    let res = {};
    const fn = (arr) => {
      if (_.isArray(arr)) {
        arr.forEach((item) => {
          if (item.category_name === name) {
            res = item;
          } else if (item.children_data && item.children_data.length > 0) {
            fn(item.children_data, name);
          }
        });
      }
    };
    fn(data);
    return res;
  };

  scrollToTop = () => {
    document.documentElement.scrollTop = 0;
  };

  toggleToast = (showToastText, showToastIserror = false) => {
    this.setState(({ showToast }) => ({
      showToast: !showToast,
      showToastText: showToastText,
      showToastIserror: showToastIserror,
    }));
  };

  callChargeErrorClosed = () => {
    this.setState({chargeError: false});
    if (!this.state.productAddSuccess && this.state.selectAgain) {
      this.selectAgainClose();
    }
  };
  // 不再弹出导入成功弹窗
  selectAgainClose = async () => {
    let getData = store.getState().languageReducer.subScriptData;
    try {
      let res = await getGetProductAddSuccess();
      if (res.code === "200") {
        this.setState({
          productAddSuccess: true,
        });
        this.props.dispatch(
          changePersonLevel(
            {
              infoData: {
                ...getData,
                bfs_pop: { ...getData.bfs_pop, is_bfs_import_product: true },
              },
            },
            true
          )
        );
       
      }
    } catch (error) {}
  };

  // 过滤表情
  filterEmoji = (str) => {
    const regex = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    return str.replace(regex, "");
  };
  getSeachTitle = () => {
    let list = this.state.dataList;
    list.forEach((item) => {
      item.checked = false;
    });

    let title = "";
    let title_info = "";
    if (this.state.queryValue !== "") {
      title = "All Categories ";
      title_info = '>"' + this.state.queryValue + '"';
    }

    this.setState(
      {
        CateValue: "",
        ProductsTitle: title,
        ProductsTitleInfo: title_info,
        page: 1,
      },
      () => {
        this.getPageData(true);
      }
    );
  };

  // 获取列表数据
  getPageData = async (isSearch = false) => {
    if (isSearch) {
      this.setState({
        isSearching: "1",
        hasPrevious: false,
        hasNext: false,
      });
    } else {
      this.setState({
        loadingPage: true,
        hasPrevious: false,
        hasNext: false,
      });
    }

    const params = {
      product_name: this.state.queryValue,
      page: this.state.page,
      size: this.state.size,
      sort: this.state.sortBy,
      category_id: this.state.CateValue,
      min_price: this.state.minPrice,
      max_price: this.state.maxPrice,
    };
    const response = await reqGetFindProductListData(params);
    if (response.code === "200") {
      let getData = response.data;
      let person = store.getState().languageReducer.subScriptData;
      if (Object.values(person).length > 0) {
        this.setState({
          productAddSuccess: person?.bfs_pop?.is_bfs_import_product
            ? person?.bfs_pop?.is_bfs_import_product
            : false,
        });
      }
      let res = await reqGetUserSubcribe();
      if (res.code === "200") {
        this.setState({
          importantLimit: Number(res?.data?.limit?.dsm),
          importantDay: Number(res?.data?.day?.dsm_product_num),
          importantAliLimit:Number(res?.data?.limit?.aliexpress + res?.data?.limit?.aliexpress_job)
        });
      }
      // let timer = setInterval(() => {
      //   if(Boolean(Object.keys(this.state.checkChromePlugins).length)) {
      //     clearInterval(timer)
      //     this.setState({
      //       loadingPage: false
      //     })
      //   }
      // }, 100)
      this.setState(
        {
          loadingPage: false,
          pageData: getData.list,
          holidayBanner: [],
          total: getData.count,
          ShowCountNumber: getData.count,
          isSearching: "0",
          pageValue: "",
          isCate: Number(getData.select_cate) === 1 ? true : false,
          
        },
        () => {
          // 更新列表数据
          this.updatePageDetail(getData.list);
        }
      );

      // 更新分页数据
      if (this.state.page > 1) {
        this.setState({
          hasPrevious: true,
        });
      } else {
        this.setState({
          hasPrevious: false,
        });
      }

      const maxPage = Math.ceil(response.data.count / this.state.size);
      if (this.state.page < maxPage) {
        this.setState({
          hasNext: true,
          PageCount: maxPage,
          total: response.data.count,
        });
      } else {
        this.setState({
          hasNext: false,
          PageCount: maxPage,
          total: response.data.count,
        });
      }
    } else {
      this.toggleToast(response.msg);
      // let timer = setInterval(() => {
      //   if(Boolean(Object.keys(this.state.checkChromePlugins).length)) {
      //     clearInterval(timer)
      //     this.setState({
      //       loadingPage: false
      //     })
      //   }
      // }, 100)
      this.setState({
        loadingPage: false,
        pageData: [],
        isSearching: "0",
      });
    }

    // 清除浏览器链接上的参数
    try {
      var currentUrl = window.location.href;
      if (currentUrl.indexOf("?") !== -1) {
        currentUrl = currentUrl.replace(/(\?|#)[^'"]*/, "");
        if (!!(window.history && window.history.pushState)) {
          window.history.pushState({}, 0, currentUrl);
        }
      }
    } catch (error) {
      console.warn(error);
    }
  };
  handleCategoryVal = (id1,val1,id2,val2,id3,val3)=>{
    this.setState({
      breadcrumbs:{
        cateTitle:val1,
        id:id1,
        bread2:{
          cateTitle:val2,
          id:id2,
          bread3:{
            cateTitle:val3,
            id:id3
          }
        }
      }
    })
  }
  handleCategory = (val, title) => {
    this.setState(
      {
        CateValue: val,
        cateSelectTitle: title,
        page:1
      },
      () => {
        this.getPageData(true);
      }
    );
  };

  handlePriceRange = (val, type) => {
    this.setState({
      [type]: val,
      priceError:false
    });
  };
  handlePriceRangeBlur = (val, type) => {
    this.setState({
      priceError:false
    })
    if (type === "maxPrice") {
      if (this.state.minPrice >= val && val !== 0) {
        this.setState({
          [type]: Math.round((Number(this.state.minPrice) + 1) * 100) / 100,
        });
        return;
      }
      this.setState({
        [type]: val <= 0 ? 0.1 :  Math.round(Number(val) * 100) / 100,
      });
    } else {
      if (Number(val) >= Number(this.state.maxPrice) && this.state.maxPrice !=='') {
        this.setState({
          [type]: Number(this.state.maxPrice) - 0.1,
        });
      }else {
      this.setState({
        [type]: val < 0 ? 0.1 : Math.round((Number(val)* 100)) / 100,
      });
    }
    }
  };
  handlePriceRangeApply = () => {
    if (this.state.minPrice !== "" && this.state.maxPrice !== "") {
      this.setState({
        currentMinPrice: this.state.minPrice,
        currentMaxPrice: this.state.maxPrice,
      })
      this.getPageData(true);
      this.togglePriceRangeActive()
    }else {
      this.setState({
        priceError:true
      })
    }
  };

  getMenu = async () => {
    let params = new URLSearchParams(window.location.search);
    let cateId  = Number(params.get("cateId"));
    const response = await reqGetFindProductCateListData();
    if ((response.code = "200")) {
      let data = response.data;
      for (let i = 0; i < data.length; i++) {
        if (data[i].category_id === cateId) {
          // setActiveData((prevValue)=>({
          //     ...prevValue,
          //     active:i,
          //     currentActive:i,
          // }))
          this.handleCategoryVal(
            data[i].category_id,
            data[i].category_name,
            "",
            "",
            "",
            ""
          );
        }
        for (let j = 0; j < data[i].children.length; j++) {
          if (data[i].children[j].category_id === cateId) {
            // setActiveData((prevValue)=>({
            //     ...prevValue,
            //     active:i,
            //     currentActive:i,
            //     active2:j,
            //     currentActive2:j,
            // }))
            this.handleCategoryVal(
              data[i].category_id,
              data[i].category_name,
              data[i].children[j].category_id,
              data[i].children[j].category_name,
              "",
              ""
            );
          }
          for (let k = 0; k < data[i].children[j].children.length; k++) {
            if (data[i].children[j].children[k].category_id === cateId) {
              // setActiveData((prevValue)=>({
              //     ...prevValue,
              //     active:i,
              //     currentActive:i,
              //     active2:j,
              //     currentActive2:j,
              //     active3:k,
              //     currentActive3:k,
              // }))
              this.handleCategoryVal(
                data[i].category_id,
                data[i].category_name,
                data[i].children[j].category_id,
                data[i].children[j].category_name,
                data[i].children[j].children[k].category_id,
                data[i].children[j].children[k].category_name
              );
            }
          }
        }
      }
      this.setState({
        cateLists: response.data,
      });
    }
  };

  getPreference = async () => {
    const response = await reqPreference();

    if (response.type === 0) {
      this.setState({
        showUserPreferences: true,
      });
    }
  };

  // 更新列表信息
  updatePageDetail(pageData) {
    let data = pageData;
    let listHtmlContent = <div></div>;
    if (data.length > 0) {
      listHtmlContent = (
        <ListItem
          data={data}
          linkPage={this.state.page}
          cateId={this.state.CateValue}
          handleToSourcingList={this.handleToSourcingList}
          handleJumpToDetail={this.handleJumpToDetail}
        />
      );
    }

    this.setState({
      ListDivHtml: listHtmlContent,
      ShowCountNumber: data.length,
    });
  }

  
  // 页面操作
  handleToSourcingList = async (recordKey, productId, cj_pid, dsm_pid) => {
    if (dsm_pid) {
      // 跳转到sourcing - product 页面
      utils.routeListen("/admin/import-list");
      utils.routeJump(this, "/admin/import-list?ids=" + dsm_pid);
      return;
    } else {
      let person = store.getState().languageReducer.subScriptData;
      // 导入限制
      if (
        (person?.level === 0 && this.state.importantLimit >= 3) ||
        (person?.level === 4 && this.state.importantLimit >= 100)
      ) {
        this.setState({ importantDsmModal: true });
        return;
      }

      //Search Product页面Add to products list按钮点击gtag
      reqGoogleAnalytics("click", "searchproduct_importproduct_click");

      // 产品导入到 sourcing - product列表
      let data = this.state.pageData;
      data[recordKey].loading = 1;
      this.setState(
        {
          pageData: data,
        }
      );
      this.updatePageDetail(data);
      const params = {
        record_id: productId,
        pid: cj_pid,
        tag: "home",
      };
      const response = await reqPostFindProductAdd(params);
      if (response.code === "200") {
        this.setState({ importantLimit: this.state.importantLimit + 1 });
        data[recordKey].dsm_pid = response.data.id;
        data[recordKey].loading = 0;

        this.setState(
          {
            pageData: data,
            chargeError: this.state.productAddSuccess ? false : true,
          }
          );
          this.updatePageDetail(data)
          setTimeout(() => {
            if (this.state.productAddSuccess) {
              this.toggleToast("Added successfully");
            }
          }, 10);
      } else {
        data[recordKey].loading = 0;
        this.setState({
          pageData: data,
        });
        store.dispatch(
          changeBannerData({
            bannerData: {
              show: true,
              desc: response.msg,
            },
          })
        );
      }
    }
  };

  /**
   * 判断链接跳转
   *
   * 说明：如果 AppBridge实例存在代表Shopify内嵌模式，否在代表Shopify站外访问
   *
   * @param {string} uri 路由，没有携带域名
   */
  handleJumpLink = (uri) => {
    if (AppBridge.exist()) {
      utils.routeListen(uri);
      utils.routeJump(this, uri);
    } else {
      try {
        // 获取当前域名
        // let localHost =
        //   window.location.protocol +
        //   "//" +
        //   window.location.hostname +
        //   (window.location.port ? ":" + window.location.port : "");

        // const w = window.open("about:blank");
        // w.location.href = localHost + uri;
        utils.routeListen(uri);
        utils.routeJump(this, uri);
      } catch (error) {
        utils.routeListen(uri);
        utils.routeJump(this, uri);
      }
    }
  };

  // 跳转到产品详情页面
  handleJumpToDetail = (id,linkPage,cateId) => {
    if (AppBridge && AppBridge.exist()) {
      this.handleJumpLink(
        "/admin/find_products/product-info?tag=home&filter=" + id+"&cateId="+cateId+"&linkPage="+linkPage+"&minPrice="+this.state.minPrice+'&maxPrice='+this.state.maxPrice
      );
      return false;
    }else {
    window.open("/admin/find_products/product-info?tag=home&filter=" + id+"&cateId="+cateId+"&linkPage="+linkPage+"&minPrice="+this.state.minPrice+'&maxPrice='+this.state.maxPrice,'_blank')
  }
    return false;
  };

  togglePriceRangeActive = () => {
    this.setState({
      priceRangeActive: !this.state.priceRangeActive,
    });
  };
  toggleClearPriceRangeActive = () => {
    this.setState({
      priceRangeActive: !this.state.priceRangeActive,
      minPrice:'',
      maxPrice:'',
    });
    
    if (this.state.currentMinPrice !== '' && this.state.currentMaxPrice !=='') {
      this.setState({
        currentMinPrice:'',
        currentMaxPrice:''
      },()=>{
        this.getPageData(true)
      });
    }
  };
  // select change
  handleSelectChange = (value) => {
    // let list = this.state.dataList;
    // list.forEach(item=>{
    //   item.checked = false;
    // })
    this.setState(
      {
        sortBy: value[0],
        page: 1,
        // CateValue:"",
        queryValue: "",
        // ProductsTitleInfo:"",
        // ProductsTitle:"",
      },
      () => {
        setTimeout(() => {
          this.getPageData(true);
        }, 600);
      }
    );
  };

  AllCategoiresClick = () => {
    let list = this.state.dataList;
    list.forEach((item) => {
      item.checked = false;
    });
    this.setState(
      {
        sortBy: "order_desc",
        CateValue: "",
        queryValue: "",
        page: 1,
        ProductsTitleInfo: "",
      },
      () => {
        this.getPageData(true);
      }
    );
  };

  // 搜索输入
  handleFiltersQueryChange = (value) => {
    this.setState({
      queryValue: this.filterEmoji(value),
      page: 1,
    });
  };

  // 浏览器url请求参数处理
  handleBrowserLink = (cateStr) => {
    try {
      var currentUrl = window.location.href;
      currentUrl = currentUrl.replace(/(\?|#)[^'"]*/, "");
      if (cateStr) {
        currentUrl = currentUrl + "?cat=" + cateStr;
      }

      if (!!(window.history && window.history.pushState)) {
        window.history.pushState({}, 0, currentUrl);
      }
    } catch (error) {
      // console.warn(error);
    }
  };

  itemClick = (item, index) => {
    //Search products页面类目按钮点击
    reqGoogleAnalytics("click", "searchproduct_categories_click");

    let list = this.state.dataList;
    let CateValue = "";
    if (list[index].checked === true) {
      list[index].checked = false;
      this.setState({
        isSelectCate: false,
        ProductsTitle: "",
        ProductsTitleInfo: "",
      });
    } else {
      list.forEach((item) => {
        item.checked = false;
      });
      list[index].checked = true;
      this.setState({
        isSelectCate: true,
        ProductsTitle: "All Categories ",
        ProductsTitleInfo: ">" + list[index].key,
      });
      CateValue = list[index].id;
    }

    this.setState(
      {
        dataList: list,
        queryValue: "",
        CateValue: CateValue,
        page: 1,
      },
      () => {
        // 更新列表数据
        this.getPageData(true);
      }
    );
  };

  

  callBackCloseModal = (data) => {
    let setParams = {};
    if (data.type) {
      setParams.ProductsTitle = "All Categories ";
    }
    setParams.showUserPreferences = false;

    this.setState(setParams);
  };

  callCouponModalClosed = () => {
    this.setState({
      CouponModal: false,
    });
  };

  getCounpon = async () => {
    let response = await reqGetCoupon();

    if (response.code === 200 && response.data.length > 0) {
      this.setState({
        CouponData: response.data,
        CouponModal: true,
      });
    }
  };

  getReceiveCounpon = async (key) => {
    let list = this.state.CouponData;

    if (list[key].display === false || !list[key]) {
      return false;
    }

    list[key].display = false;

    let response = await reqReceiveCoupon({
      id: list[key].id,
      tokens: list[key].tokens,
    });

    if (response.code === 200) {
      this.setState({
        CouponData: list,
      });
      this.toggleToast(response.msg, false);
    } else {
      this.toggleToast(response.msg);
    }
  };

  // 检测谷歌插件
  checkGooglePlugin = (id) => {
    var image = document.createElement("img");
    let _this = this;
    // 必须要启用该插件才可用
    image.src = `chrome-extension://${id}/logo128.png`;
    image.onload = function () {
      _this.setState({
        loadingPage: false,
        GooglePluginInstall: true,
      });
    };
    image.onerror = function () {
      _this.setState({
        loadingPage: false,
        GooglePluginInstall: false,
      });
    };
  };

  // 切换谷歌插件弹窗开关
  handleCheckGooglePluginModal = () => {
    this.setState(({ CheckGooglePluginActive }) => ({
      CheckGooglePluginActive: !CheckGooglePluginActive,
    }));
  };

  // 跳转Url
  jumpUrl = (url) => {
    try {
      window.open(url);
      this.handleCheckGooglePluginModal();
    } catch (error) {
      console.log(error);
    }
  };
  shopifyLevel = ()=>{
    let shopify_level = store.getState().languageReducer.subScriptData.shopify_level;
    let level = store.getState().languageReducer.subScriptData.level;
    let flag = true;
    if ((level !== 2 || level !== 3) && ( shopify_level === 'Development' || shopify_level === 'Developer Preview' || shopify_level === 'staff' || shopify_level === 'staff_business')) {
      flag = false
    }
    return flag;
  }
  shopifyLevel2 = ()=>{
    let shopify_level = store.getState().languageReducer.subScriptData.shopify_level;
    let level = store.getState().languageReducer.subScriptData.level;
    let flag = true;
    if (level === 0 && ( shopify_level === 'Development' || shopify_level === 'Developer Preview' || shopify_level === 'staff' || shopify_level === 'staff_business')) {
      flag = false
    }
    return flag;
  }
  shopifyLevel3 = ()=>{
    let shopify_level = store.getState().languageReducer.subScriptData.shopify_level;
    let flag = true;
    if (( shopify_level === 'Development' || shopify_level === 'Developer Preview' || shopify_level === 'staff' || shopify_level === 'staff_business')) {
      flag = false
    }
    return flag;
  }

  // sourcing from 1688的点击事件
  sourcingFrom1688Click = (id) => {
    this.checkGooglePlugin(id);
    this.handleCheckGooglePluginModal();
  };

  // 非会员阻断浏览trendy商品限制
  handleToTrendyProduct = (type) => {
    // let person = Object.values(this.props.subScriptData).length > 0 ? this.props.subScriptData : store.getState().languageReducer.subScriptData;
    let person = store.getState().languageReducer.subScriptData;
    switch (type) {
      case "trendy":
        if (person?.level >= 2 && person?.level !== 4) {
          if (AppBridge && AppBridge.exist()) {
            utils.routeListen("/admin/find_products/trendy-products/trendy");
            utils.routeJump(this, "/admin/find_products/trendy-products/trendy");
          }else {
            window.open("/admin/find_products/trendy-products/trendy",'_blank')
          }
          
        } else {
          this.setState({ upgradeModal: true });
        }
        break;
      case "winning":
        if (person?.level >= 2 && person?.level !== 4) {
          if (AppBridge && AppBridge.exist()) {
            utils.routeListen(
              "/admin/find_products/recommended-category/winning"
            );
            utils.routeJump(
              this,
              "/admin/find_products/recommended-category/winning"
            );
          }else {
            window.open("/admin/find_products/recommended-category/winning",'_blank')
          }
          
        } else {
          this.setState({ upgradeModal: true });
        }

        break;
      case 'new':
        if (AppBridge && AppBridge.exist()) {
          utils.routeListen(
            "/admin/find_products/new-products"
          );
          utils.routeJump(
            this,
            "/admin/find_products/new-products"
          );
        }else {
          window.open("/admin/find_products/new-products",'_blank')
        }
        break;

      default:
        break;
    }
  };

  // 偏好选择
  handleChangeSelect = (value) => {
    let list = this.state.cateSelectData.map((item, ind) => {
      if (item.value === value) {
        return { ...item, select: item?.select === 1 ? 0 : 1 };
      } else {
        return item;
      }
    });
    let len = list.filter((sl) => {
      return sl.select === 1;
    });
    if (len.length <= 5) {
      this.setState({
        cateSelectData: list,
      });
    } else {
      this.setState({
        warningMessage: "Maximum 5 categories allowed",
      });
      // this.toggleToast("Maximum 5 categories allowed", true);
    }
  };
  // 保存选择
  onSubmitSelect = async () => {
    let len = this.state.cateSelectData.filter((sl) => {
      return sl.select === 1;
    });
    if (len.length > 0) {
      let ids = [];
      for (let i = 0; i < len.length; i++) {
        if (len[i].select === 1) {
          ids.push(len[i].value);
        }
      }
      let params = {
        cate_ids: ids,
      };
      try {
        this.setState({
          selectCateLoading: true,
        })
        let res = await getPostCateSelect(params);
        if (res.code === "200") {
          this.toggleToast("Added successfully");
          this.setState({
            warningMessage: "",
          });
          this.setState(
            {
              isCate: false,
            },
            () => {
              this.getPageData();
            }
          );
        }
      } catch (error) {}
    } else {
      this.setState({
        warningMessage: "Please select at least one category",
      });
      // this.toggleToast("Please select at least one category.", true);
    }
    this.setState({
      selectCateLoading: false,
    })
  };

  // 取消
  onCancelSelect = async () => {
    this.setState({
      warningMessage: "",
      selectCateLoading: false
    });
    let list = this.state.cateSelectData.map((item, ind) => {
      return { ...item, select: 0 };
    });
    try {
      let params = {
        cate_ids: [],
      };
      let res = await getPostCateSelect(params);
      if (res.code === "200") {
        this.setState({
          cateSelectData: list,
          isCate: false,
        });
      }
    } catch (error) {}
  };



// 点击aliexpress 1688 导入产品的按钮
setAliImportModal =(val)=>{
  this.setState(
    {
      aliImportModal:val
    }
  )
}
   handleOtherOnChange = (type, open) => {
    let person = store.getState().languageReducer.subScriptData;
    // 导入限制&& importantLimit >= 5 
    if (person.level === 0 ) {
      this.setState({ upgradeModal: true })
      return;
    }
    if ((person.level === 4 && this.state.importantAliLimit >= 100)) {
      this.setAliImportModal(true)
      return
    }
    this.setState({
      otherImportParams:{
        open:true
      }
    })
  }

  render() {
    
    const toastMarkup = this.state.showToast ? (
      <Toast
        content={this.state.showToastText}
        onDismiss={() => this.toggleToast("")}
        error={this.state.showToastIserror}
        duration={1500}
      />
    ) : null;
    const {
      isSearching,
      ShowCountNumber,
      ListDivHtml,
      CheckGooglePluginActive,
      GooglePluginInstall,
      holidayBanner,
      warningMessage,
    } = this.state;
    const initSkeletonPage = (
      <div>
        <SkeletonPage fullWidth={true}>
         <Layout>
            <Layout.Section>
              <div className="find-product-cate-list">
                {[1, 2, 3].map((item, key) => (
                  <div key={key} className="find-product-cate-list-item">
                    <SkeletonDisplayText size="large" />
                  </div>
                ))}
              </div>
              <div className="find-product-list">
                <SkeletonDisplayText size="large" />
              </div>
              <div className="find-product-list">
                <SkeletonDisplayText size="large" />
              </div>
              <div className="product-list">
                {[1, 2, 3, 4, 5,1, 2, 3, 4, 5].map(
                  (item, key) => (
                    <div key={key} className="find-product-item">
                      <Card>
                        <BlockStack gap={400}>
                          <SkeletonDisplayText size="large" />
                          <SkeletonBodyText lines={3} />
                        </BlockStack>
                      </Card>
                    </div>
                  )
                )}
              </div>
            </Layout.Section>
          </Layout>
        </SkeletonPage>
      </div>
    );

    const EmptyProductList =
      ShowCountNumber === 0 ? (
        <div style={{ textAlign: "center", height:'500px',display:'flex',alignItems:'center',justifyContent:'center' }} className="find_product_empt">
          <EmptyState heading={''} image="/empty.svg">
          <div className="find_product_empt_box">
          <p style={{ fontSize: "16px", opacity: "1", marginBottom: "16px" }}>
            {intl.get("Sorry, no results found. ")}
          </p>
          <p style={{ fontSize: "16px", opacity: "1", marginBottom: "16px",lineHeight:1.5 }}>
            {intl.get(
              "Please check your spelling or try different keywords. "
            )}
          </p>
          <p style={{ fontSize: "16px", opacity: "1", marginBottom: "0" }}>
            {intl.get("Or you can submit a")}
            <span
              className="Polaris-Link"
              onClick={() => {
                utils.routeListen("/admin/sourcing");
                utils.routeJump(this, "/admin/sourcing");
              }}
              style={{ textDecoration: "none" }}
            >
              {" "}
              {intl.get("sourcing request.")}
            </span>
          </p>
        </div>
          </EmptyState>
        </div>
      ) : (
        ""
      );

    var footerContentMsg = "";
    if (this.state.total > 0) {
      const startNum = (this.state.page - 1) * this.state.size + 1;
      const endNum =
        this.state.page * this.state.size > this.state.total
          ? this.state.total
          : this.state.page * this.state.size;
      // footerContentMsg = <div className="Pagination_Result__Footer">{"Showing " + startNum + " - "+ endNum + " of " + this.state.total + " results"}</div>;
      footerContentMsg = (
        <div>
          {intl.get(
            "Showing {{startNum}} - {{endNum}} of {{total}} results (Total {{PageCount}} pages)",
            startNum,
            endNum,
            this.state.total,
            this.state.PageCount
          )}
        </div>
      );
    }

    const PaginationSettings = this.state.loadingPage ? (
      ""
    ) : ShowCountNumber !== 0 ? (
      <div className="Polaris-New-Pagination">
        <Pagination
          label={footerContentMsg}
          hasPrevious={this.state.hasPrevious}
          onPrevious={() => {
            this.setState({ page: Number(this.state.page) - 1 }, () => {
              this.getPageData(true);
            });
          }}
          hasNext={this.state.hasNext}
          onNext={() => {
            this.setState({ page: Number(this.state.page) + 1 }, () => {
              this.getPageData(true);
            });
          }}
        />
        <div>
          <input
            className="Page_input"
            type="text"
            value={this.state.pageValue}
            maxLength={"8"}
            onChange={(e) => {
              if (Number.isInteger(Number(e.target.value))) {
                this.setState({
                  pageValue: e.target.value,
                });
              }
            }}
          />
          <span
            className="Page_Jump"
            onClick={() => {
              if (this.state.PageCount === 1) return false;
              let page = 1;
              if (this.state.pageValue > this.state.PageCount) {
                page = this.state.PageCount;
              }
              if (
                this.state.pageValue > 1 &&
                this.state.pageValue <= this.state.PageCount
              ) {
                page = this.state.pageValue;
              }

              this.setState(
                {
                  page: page,
                },
                () => {
                  this.getPageData(true);
                }
              );
            }}
          >
            {intl.get("Go to")}
          </span>
        </div>
      </div>
    ) : (
      ""
    );

    // 控制列表两个产品之间间距显示
    let smallSpacingClass = ShowCountNumber <= 4 ? "small_spacing" : "";

    const SingleOperationTipsModal = (
      <Modal
        open={this.state.chargeError}
        onClose={this.callChargeErrorClosed}
        title={intl.get("Product imported successfully")}
      >
        <Box className="product_success_content">
          <div style={{ fontSize: "16px", color: "#202223", padding: "16px" }}>
            {intl.get("You can go to the")}{" "}
            <span
              style={{ fontSize: "16px", fontWeight: 700, color: "#303030" }}
            >
              {intl.get("List Products > Not Listed")}
            </span>{" "}
            {intl.get("to view and edit the product.")}
          </div>

          <Box className="product_success_button">
            <Checkbox
              checked={this.state.selectAgain}
              label={intl.get("Don't remind me again")}
              onChange={() =>
                this.setState({
                  selectAgain: !this.state.selectAgain,
                })
              }
            />
            <Button variant="primary" onClick={this.callChargeErrorClosed}>
              {intl.get("OK")}
            </Button>
          </Box>
        </Box>
      </Modal>
    );

    let clientWidth = document.documentElement.clientWidth;
    // let SlidePercentage = 100;
    switch (true) {
      case clientWidth <= 1024:
        // SlidePercentage = 100;
        break;

      case clientWidth > 1024 && clientWidth <= 1440:
        // SlidePercentage = 30;
        break;

      case clientWidth > 1440:
        // SlidePercentage = 20;
        break;

      default:
    }

    // 轮播组件全局配置
    // const globalConfig = {
    //   autoPlay: false,
    //   interval: 5000,
    //   selectedItem: 1,
    //   showArrows: true,
    //   showIndicators: false,
    //   showStatus: false,
    //   infiniteLoop: true,
    //   showThumbs: false,
    //   centerMode: true,
    //   centerSlidePercentage: SlidePercentage,
    // };

    // 轮播按钮样式
    // const arrowStyles = {
    //   position: "absolute",
    //   zIndex: 2,
    //   top: "calc(50% - 15px)",
    //   width: 30,
    //   height: 30,
    //   cursor: "pointer",

    // };
    // 轮播组件全局配置
    const globalConfigs = {
      autoPlay: true,
      interval: 5000,
      showArrows: true,
      showIndicators: holidayBanner.length > 0 ? true : false,
      showStatus: false,
      infiniteLoop: true,
      showThumbs: false,
    };
    const globalConfig2 = {
      showArrows: false,
      autoPlay: true,
      interval: 5000,
      showStatus: false,
      infiniteLoop: true,
      showThumbs: false,
    };
    const pageContent = this.state.loadingPage ? (
      initSkeletonPage
    ) : (
      <section style={{ margin: "0 auto" }}>
        {/* 下架 */}
        {/* <div className='Polaris-Page Polaris-Page--fullWidth'>
          <div className='ramadan' onClick={this.handleClickRamadan}>
            <img src={this.state.ramadanImage} alt='ramadan' />
          </div>
        </div> */}
        <Page
          // title={intl.get('Search Product')}
          // subtitle={intl.get(
          //   'A large number of good goods from Dropshipman to meet all your needs'
          // )}
          fullWidth
          // primaryAction={
          //   <Button plain onClick={() => this.props.history.push('/admin/calculate-shipping')}>
          //     {intl.get('Freight calculation')}
          //   </Button>
          // }
        >
          <Layout>
            <Layout.Section>
              {holidayBanner.length > 0 && (
                <div className="holiday_banner">
                  <Carousel {...globalConfigs}>
                    {holidayBanner.map((item, ind) => (
                      <div
                        key={ind}
                        onClick={() => {
                          if (item.url === "spring-festival") {
                            window.open(
                              "https://www.dropshipman.com/blog/dropshipman-2024-chinese-new-year-notice",
                              "_blank"
                            );
                          } else {
                            utils.routeListen(
                              "/admin/find_products/new-products"
                            );
                            utils.routeJump(
                              this,
                              "/admin/find_products/new-products?holiday=" +
                                item.url
                            );
                          }
                        }}
                        className="holiday_item"
                        // style={{ backgroundImage: `url(${item.src})` }}
                      >
                        <img
                          style={{ maxWidth: "100%" }}
                          src={item.src}
                          alt="holiday"
                        />
                      </div>
                    ))}
                  </Carousel>
                </div>
              )}
              {AppBridge.exist() ? (
                ""
              ) : (
                <div className="search_product_head">
                  <div className="search_product_head_h1">
                    <h1>{intl.get("Find Products")}</h1>
                    <p>
                      {intl.get(
                        "Dropshipman brings you a world of fantastic products right to your doorstep!"
                      )}
                    </p>
                  </div>
                  
                </div>
              )}
              <Box className="top_cate_box top_cate_box_pc">
                <Box
                  className={"top_cate_box_item"}
                  onClick={() => this.handleToTrendyProduct("trendy")}
                >
                  <img
                    src="/new-product/trendy_product.png"
                    alt="Dropshipman"
                  />
                 {!this.shopifyLevel() && <LevelAction img={'20px'} callBack={()=>this.handleToTrendyProduct("trendy")} borderRadius={'16px'} bg={'rgb(110 108 108 / 60%)'}/> }
                </Box>
                <Box
                  className={"top_cate_box_item"}
                  onClick={() => this.handleToTrendyProduct("winning")}
                >
                  <img
                    src="/new-product/winning_product.png"
                    alt="Dropshipman"
                  />
                   {!this.shopifyLevel() && <LevelAction img={'20px'} callBack={()=>this.handleToTrendyProduct("winning")} borderRadius={'16px'} bg={'rgb(110 108 108 / 60%)'}/> }
                </Box>
                <Box
                  className="top_cate_box_item"
                  onClick={() =>  this.handleToTrendyProduct("new")}
                >
                  <img src="/new-product/new_product.png" alt="Dropshipman" />
                </Box>
              </Box>
              <Box className="top_cate_box top_cate_box_mob">
              <Carousel {...globalConfig2}>
              <Box
                  className={"top_cate_box_item"}
                  onClick={() => this.handleToTrendyProduct("trendy")}
                >
                  <img
                    src="/new-product/trendy_product_m.png"
                    alt="Dropshipman"
                  />
                   {!this.shopifyLevel() && <LevelAction img={'20px'} callBack={()=>this.handleToTrendyProduct("trendy")} borderRadius={'16px'} bg={'rgb(110 108 108 / 60%)'}/> }
                </Box>
                <Box
                  className={"top_cate_box_item"}
                  onClick={() => this.handleToTrendyProduct("winning")}
                >
                  <img
                    src="/new-product/winning_product_m.png"
                    alt="Dropshipman"
                  />
                   {!this.shopifyLevel() && <LevelAction img={'20px'} callBack={()=>this.handleToTrendyProduct("winning")} borderRadius={'16px'} bg={'rgb(110 108 108 / 60%)'}/> }
                </Box>
                <Box
                  className="top_cate_box_item"
                  onClick={() =>  this.handleToTrendyProduct("new")}
                >
                  <img src="/new-product/new_product_m.png" alt="Dropshipman" />
                </Box>
                  </Carousel>
              </Box>
              <Box className="cate_box_list">
                <div className="cate_list" style={{ position: "relative" }}>
                  <div
                    className="input_search_div"
                    style={{
                      flex: 1,
                      margin: "0 20px 0 0",
                      position: "relative",
                    }}
                  >
                    <input
                      type="text"
                      placeholder={intl.get("Search Products")}
                      autoComplete="off"
                      maxLength="100"
                      value={this.state.queryValue}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          this.getSeachTitle();
                        }
                      }}
                      className="search_input"
                      onChange={(e) => {
                        this.handleFiltersQueryChange(e.target.value);
                      }}
                    />
                    <div
                      className="search_input_img"
                      onClick={() => {
                        this.getSeachTitle();
                      }}
                    >
                     <Icon
                      source={SearchMajor}
                      tone="base"
                    />
                    </div>

                    {false && (
                      <div className="search_input_img_camera">
                        <label>
                          <div>
                            <img src={"/camera.png"} alt="" />
                          </div>
                          <input
                            type="file"
                            ref={"myRef"}
                            id="file-input"
                            accept=".jpg,.jpeg,.png"
                            onChange={async (e) => {
                              this.setState({
                                SeachImage: true,
                                Imageload: true,
                              });
                              let formData = new FormData();
                              formData.append("file", e.target.files[0]);
                              const response = await reqFileMapSearch(formData);
                              e.target.value = "";
                              this.setState({
                                SeachImage: false,
                                Imageload: false,
                              });
                              utils.routeListen("/admin/search/image");
                              utils.routeJump(
                                this,
                                "/admin/search/image?result=" +
                                  response.data.list +
                                  "&url=" +
                                  response.data.url
                              );
                            }}
                            style={{ display: "none" }}
                          />
                        </label>
                      </div>
                    )}
                  </div>
                  <div className="filter_button">
                    {/* <div className="cate_hover_find">
                      <Button onClick={()=>this.setState({categories:!this.state.categories})}>
                        <InlineStack align="space-between">
                          <Text>All Categories</Text>
                          <Icon source={CaretDownMinor} tone="base" />
                        </InlineStack>
                      </Button>
                    </div> */}
                    <div className="price_range_find">
                      <Popover
                        active={this.state.priceRangeActive}
                        activator={
                           <Button onClick={() => this.togglePriceRangeActive()} disclosure>
                           <InlineStack blockAlign="space-between">
                           <span>{(this.state.currentMinPrice !=='' && this.state.currentMaxPrice !== '') ? `$${this.state.currentMinPrice} - $${this.state.currentMaxPrice}` : intl.get("Price range")}</span>
                       </InlineStack>
                       </Button>
                        }
                        autofocusTarget="container"
                        onClose={()=>this.togglePriceRangeActive()}
                      >
                        <div className="price_range_find_content">
                          <div style={{ fontSize: 16, fontWeight: 600 }}>
                            Price range
                          </div>
                          <div className="price_range_find_input">
                            <div>
                              <input
                                type="text"
                                className={this.state.priceError && this.state.minPrice === '' ? 'border_input_price' : '' }
                                onBlur={(e) => {
                                  if (
                                    !isNaN(parseFloat(e.target.value))
                                  ) {
                                    this.handlePriceRangeBlur(
                                      Number(e.target.value),
                                      "minPrice"
                                    );
                                  }
                                }}
                                onChange={(e) => {
                                  if (
                                    !isNaN(parseFloat(e.target.value)) || e.target.value === ''
                                  ) {
                                    this.handlePriceRange(
                                      e.target.value,
                                      "minPrice"
                                    );
                                  }
                                }}
                                maxLength={6}
                                value={this.state.minPrice}
                                placeholder="$ Min"
                              />
                            </div>
                            <div>
                              <Icon source={MinusMinor} tone="base" />
                            </div>
                            <div>
                              <input
                                type="text"
                                maxLength={6}
                                className={this.state.priceError && this.state.maxPrice === '' ? 'border_input_price' : '' }
                                onBlur={(e) => {
                                  if (
                                    !isNaN(parseFloat(e.target.value))
                                  ) {
                                    this.handlePriceRangeBlur(
                                      Number(e.target.value),
                                      "maxPrice"
                                    );
                                  }
                                }}
                                onChange={(e) => {
                                  if (
                                    !isNaN(parseFloat(e.target.value)) || e.target.value === ''
                                  ) {
                                    this.handlePriceRange(
                                      e.target.value,
                                      "maxPrice"
                                    );
                                  }
                                }}
                                value={this.state.maxPrice}
                                placeholder="$ Max"
                              />
                            </div>
                          </div>
                          <p style={{visibility: this.state.priceError ? 'visible' : 'hidden',margin:'5px 0',color:'red'}}>Price is required.</p>
                          <div className="price_range_find_button">
                            <Button
                              onClick={() => this.toggleClearPriceRangeActive()}
                            >
                              Clear
                            </Button>
                            <Button
                              variant="primary"
                              onClick={() => this.handlePriceRangeApply()}
                            >
                              Apply
                            </Button>
                          </div>
                        </div>
                      </Popover>
                    </div>
                  </div>
                  <CateTab
                    CateValue={this.state.CateValue}
                    handleCategory={this.handleCategory}
                    handleCategoryVal={this.handleCategoryVal}
                    data={this.state.cateLists}
                    show={this.state.categories}
                    onShow={() =>
                      this.setState({ categories: false })
                    }
                  />
                </div>
              </Box>
              <Box>
                <CateClass
                  CateValue={this.state.CateValue}
                  handleCategory={this.handleCategory}
                  handleCategoryVal={this.handleCategoryVal}
                  data={this.state.currentCateList}
                  onShow={() =>
                    this.setState({ categories: !this.state.categories })
                  }
                />
              </Box>
              {/* 数据为空显示 */}
              <div style={{ position: "relative" }}>
                {EmptyProductList}

                <div
                  className="Product__Loading"
                  style={{
                    display:
                      isSearching === "1" && ShowCountNumber === 0
                        ? "block"
                        : "none",
                    backgroundColor: "unset",
                  }}
                >
                  <div className="Product__Loading_Image">
                    <img
                      style={{
                        width: "32px",
                        height: "32px",
                        verticalAlign: "middle",
                      }}
                      src="/loading.gif"
                      alt="loading"
                    />
                  </div>
                </div>
              </div>

             {this.state.pageData.length > 0 && <div
                className="Products_top"
                style={{margin:'24px 0',display:'flex',alignItems:'center'}}
              >
                {this.state.breadcrumbs.cateTitle !=='' &&<div className="products_top_title1">
                  <span>{this.state.breadcrumbs.cateTitle}</span>
                </div>}
                {this.state.breadcrumbs.bread2.cateTitle !=='' &&<div className="products_top_title2">
                <Icon
                source={ChevronRightMinor}
                tone="base"
              />
              <span>{this.state.breadcrumbs.bread2.cateTitle}</span>
                </div>}
                {this.state.breadcrumbs.bread2.bread3.cateTitle !=='' &&<div className="products_top_title3">
                <Icon
                source={ChevronRightMinor}
                tone="base"
              />
              <span>
                {this.state.breadcrumbs.bread2.bread3.cateTitle}
              </span>
                </div>}
              </div>}

              {/* Start: Find products 列表 */}
              <div style={{ position: "relative" }}>
                <div>
                  {/* <section className="Product_Resource_Wrapper">
                  <div className="Border_Mask Left"></div>
                  <div className="Border_Mask Right"></div>
                  <div className="Border_Mask Bottom"></div>
                */}
                  <div
                    className={
                      "Product_Resource_Container " + smallSpacingClass
                    }
                  >
                    {/* 列表 div 对象 */}
                    {ListDivHtml}
                  </div>
                </div>
                {/* </section> */}

                <div
                  className="Product__Loading"
                  style={{
                    display:
                      isSearching === "1" && ShowCountNumber > 0
                        ? "block"
                        : "none",
                  }}
                >
                  <div className="Product__Loading_Image">
                    <img
                      style={{
                        width: "32px",
                        height: "32px",
                        verticalAlign: "middle",
                      }}
                      src="/loading.gif"
                      alt="loading"
                    />
                  </div>
                </div>
              </div>
              {/* End: 列表 */}

              {/* 分页 */}
              <div className="find_product_bottom_content">
                <div className="find_product_bottom_content_item">
                  <div className="bottom_content_item_left" style={{position:'relative'}}>
                    <Button
                    onClick={()=>this.handleOtherOnChange()}
                      icon={
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.75 13.25C16.1642 13.25 16.5 13.5858 16.5 14V14.51C16.5 15.7526 15.4926 16.76 14.25 16.76L5.75 16.76C4.50736 16.76 3.5 15.7526 3.5 14.51V14C3.5 13.5858 3.83579 13.25 4.25 13.25C4.66421 13.25 5 13.5858 5 14V14.51C5 14.9242 5.33579 15.26 5.75 15.26L14.25 15.26C14.6642 15.26 15 14.9242 15 14.51V14C15 13.5858 15.3358 13.25 15.75 13.25Z"
                            fill="#202223"
                          />
                          <path
                            d="M10.6498 9.12215C10.6256 9.41803 10.6244 10.0026 10.6244 10.575L10.6244 10.8144L11.3441 10.0947C11.637 9.80178 12.1119 9.80178 12.4048 10.0947C12.6977 10.3876 12.6977 10.8624 12.4048 11.1553L10.4048 13.1553C10.326 13.2341 10.2341 13.2917 10.136 13.3281C10.0546 13.3584 9.96643 13.375 9.87442 13.375C9.69735 13.375 9.53462 13.3136 9.40632 13.211C9.38247 13.192 9.3598 13.1714 9.33846 13.1496L7.34409 11.1553C7.0512 10.8624 7.05119 10.3876 7.34408 10.0947C7.63697 9.80178 8.11184 9.80177 8.40474 10.0947L9.12442 10.8143L9.12442 10.5446C9.12441 10.0104 9.12498 9.36423 9.15474 9C9.18578 8.62012 9.25289 8.26346 9.42473 7.9262C9.68838 7.40875 10.1091 6.98805 10.6265 6.7244C10.9638 6.55256 11.3204 6.48545 11.7003 6.45441C12.0646 6.42465 12.5104 6.42466 13.0446 6.42467L13.375 6.42467C13.7892 6.42467 14.125 6.76046 14.125 7.17467C14.125 7.58888 13.7892 7.92467 13.375 7.92467L13.075 7.92467C12.5026 7.92467 12.1184 7.92525 11.8225 7.94943C11.5354 7.97289 11.3981 8.01477 11.3075 8.06091C11.0723 8.18075 10.8811 8.37198 10.7612 8.60718C10.7151 8.69774 10.6732 8.83502 10.6498 9.12215Z"
                            fill="#202223"
                          />
                        </svg>
                      }
                    >
                      Import products from <strong style={{color:this.shopifyLevel3() ? "#f5520c" : '#202333'}}>AliExpress</strong>
                    </Button>
                    {!this.shopifyLevel2() && <LevelAction callBack={()=>this.handleOtherOnChange()} img={'16px'} borderRadius={'5px'} font={'12px'}/> }
                  </div>
                  <div>
                    <Button
                      onClick={()=>this.setState({temuModal:true})}
                      icon={
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.75 13.25C16.1642 13.25 16.5 13.5858 16.5 14V14.51C16.5 15.7526 15.4926 16.76 14.25 16.76L5.75 16.76C4.50736 16.76 3.5 15.7526 3.5 14.51V14C3.5 13.5858 3.83579 13.25 4.25 13.25C4.66421 13.25 5 13.5858 5 14V14.51C5 14.9242 5.33579 15.26 5.75 15.26L14.25 15.26C14.6642 15.26 15 14.9242 15 14.51V14C15 13.5858 15.3358 13.25 15.75 13.25Z"
                            fill="#202223"
                          />
                          <path
                            d="M10.6498 9.12215C10.6256 9.41803 10.6244 10.0026 10.6244 10.575L10.6244 10.8144L11.3441 10.0947C11.637 9.80178 12.1119 9.80178 12.4048 10.0947C12.6977 10.3876 12.6977 10.8624 12.4048 11.1553L10.4048 13.1553C10.326 13.2341 10.2341 13.2917 10.136 13.3281C10.0546 13.3584 9.96643 13.375 9.87442 13.375C9.69735 13.375 9.53462 13.3136 9.40632 13.211C9.38247 13.192 9.3598 13.1714 9.33846 13.1496L7.34409 11.1553C7.0512 10.8624 7.05119 10.3876 7.34408 10.0947C7.63697 9.80178 8.11184 9.80177 8.40474 10.0947L9.12442 10.8143L9.12442 10.5446C9.12441 10.0104 9.12498 9.36423 9.15474 9C9.18578 8.62012 9.25289 8.26346 9.42473 7.9262C9.68838 7.40875 10.1091 6.98805 10.6265 6.7244C10.9638 6.55256 11.3204 6.48545 11.7003 6.45441C12.0646 6.42465 12.5104 6.42466 13.0446 6.42467L13.375 6.42467C13.7892 6.42467 14.125 6.76046 14.125 7.17467C14.125 7.58888 13.7892 7.92467 13.375 7.92467L13.075 7.92467C12.5026 7.92467 12.1184 7.92525 11.8225 7.94943C11.5354 7.97289 11.3981 8.01477 11.3075 8.06091C11.0723 8.18075 10.8811 8.37198 10.7612 8.60718C10.7151 8.69774 10.6732 8.83502 10.6498 9.12215Z"
                            fill="#202223"
                          />
                        </svg>
                      }
                    >
                      Import products from <strong style={{color:this.shopifyLevel3() ? "#f5520c" : '#202333'}}>TEMU</strong>
                    </Button>
                  </div>
                </div>
                <div className="find_product_bottom_content_item">
                  {PaginationSettings}
                </div>
              </div>
            </Layout.Section>
          </Layout>
        </Page>
      </section>
    );

    // 返回顶部按钮
    const RoundButton = (
      <Link onClick={this.scrollToTop} external={false}>
        <div className="top_position">
          <div className="up_major">
            {/* <img
              src={"/xiangshang.png"}
              style={{ width: "35px", height: "35px" }}
              alt=""
            /> */}
            <Icon source={UploadMajor} />
          </div>
        </div>
      </Link>
    );
    // 优惠券弹窗
    const CouponPopModal = (
      <Modal open={this.state.CouponModal} onClose={this.callCouponModalClosed}>
        {/* <Modal.Section> */}
        <div style={{ background: "#f1f1f1", padding: "2rem" }}>
          <div className="coupon_title">
            {intl.get("Congratulations on getting the coupon")}
          </div>
          <div className="coupon_title_tips">
            {intl.get("Coupons help you save more")}
          </div>

          {this.state.CouponData.map((item, key) => {
            return (
              <div
                className="coupon_list"
                key={"coupon" + key}
                style={{
                  backgroundImage: "url(/blackFriday/coupon_bg_new.png)",
                  width: "80%",
                }}
              >
                <div className="coupon_list_pop">
                  <div className="coupon_pop_left">
                    <div className="coupon_pop_text">
                      <span className="coupon_pop_text_span">
                        ${item.money} USD{" "}
                      </span>
                      <span className="coupon_pop_text_span_two">
                        {intl.get("Available for Dropshipman orders")}
                      </span>
                    </div>
                    <div className="coupon_pop_text_bottom">
                      {intl.get(
                        "Orders over $ {{full_money}} USD",
                        item.full_money
                      )}{" "}
                      |{" "}
                      {moment(item.start_time * 1000)
                        .locale("en")
                        .format("LL") +
                        " - " +
                        moment(item.end_time * 1000)
                          .locale("en")
                          .format("LL")}{" "}
                    </div>
                  </div>

                  <div className="coupon_pop_right">
                    {item.display ? (
                      <Button
                        id="coupon_pop_button1"
                        onClick={() => {
                          this.getReceiveCounpon(key);
                        }}
                      >
                        {intl.get("Claim")}
                      </Button>
                    ) : (
                      <Button
                        id="coupon_pop_button2"
                        disabled={true}
                        onClick={() => {
                          this.getReceiveCounpon(key);
                        }}
                      >
                        {intl.get("Claim")}
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {/* </Modal.Section> */}
      </Modal>
    );

    // 偏好选择弹窗
    const CateSelectPopModal = (<Modal
        open={this.state.isCate}
        title={intl.get("Select your recommended picks")}
        onClose={() => this.onCancelSelect()}
        primaryAction={{
          content: intl.get("Submit"),
          onAction: () => this.onSubmitSelect(),
          loading:this.state.selectCateLoading
        }}
        secondaryActions={[
          {
            content: intl.get("Skip"),
            onAction: () => this.onCancelSelect(),
          },
        ]}
      >
        <Box className="select_cate_content">
          {warningMessage !== "" && (
            <Banner
              title="Error reminder"
              tone="critical"
              onDismiss={() => {
                this.setState({
                  warningMessage: "",
                });
              }}
            >
              {warningMessage}
            </Banner>
          )}
          <Box>
            {intl.get(
              "Please select the product category you are looking for, and we will recommend products in the corresponding category for you."
            )}
          </Box>
          <Box className="select_cate_box">
            {this.state.cateSelectData.map((item, ind) => (
              <Box className="select_cate_box_item" key={ind}>
                <Checkbox
                  label={item.label}
                  checked={item.select}
                  onChange={() => this.handleChangeSelect(item.value)}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Modal>)
      // :<CommonModalApp 
      // title={intl.get("Select your recommended picks")} 
      // content={
      // <Box className="select_cate_content">
      // {warningMessage !== "" && (
      //   <Banner
      //     title="Error reminder"
      //     tone="critical"
      //     onDismiss={() => {
      //       this.setState({
      //         warningMessage: "",
      //       });
      //     }}
      //   >
      //     {warningMessage}
      //   </Banner>
      // )}
      // <Box>
      //   {intl.get(
      //     "Please select the product category you are looking for, and we will recommend products in the corresponding category for you."
      //   )}
      // </Box>
      // <Box className="select_cate_box">
      //   {this.state.cateSelectData.map((item, ind) => (
      //     <Box className="select_cate_box_item" key={ind}>
      //       <Checkbox
      //         label={item.label}
      //         checked={item.select}
      //         onChange={() => this.handleChangeSelect(item.value)}
      //       />
      //     </Box>
      //   ))}
      // </Box>
      // </Box>}
      // open={this.state.isCate}
      // priamry={intl.get("Submit")} 
      // cancel={intl.get("Skip")}
      // size={'base'}
      // callSave={this.onSubmitSelect}
      // callCancel={this.onCancelSelect}
      // priamryLoading={this.state.selectCateLoading}
      // />;
    // 黑色星期五活动图片
    // const blackFridayBanner = !this.state.loadingPage && (
    //   <div
    //      className='black_friday_banner'
    //      onClick={()=>this.props.history.push('/admin/black-friday')}
    //      style={{
    //         backgroundImage: 'url(/blackFriday/banner_img.png)',
    //         marginTop: '3rem'
    //      }}>
    //   </div>
    // )

    let CheckGooglePluginMessage;
    if (GooglePluginInstall) {
      CheckGooglePluginMessage = (
        <ol className="check_google_plugin_ol">
          <li>
            {intl.get("Go to 1688")}{" "}
            <Link onClick={() => this.jumpUrl("https://www.1688.com")} external>
              https://www.1688.com
            </Link>
          </li>
          <li>
            {intl.get(
              "Select the products you want to import to your Shopify store, enter the product details page."
            )}
          </li>
          <li>
            {intl.get(
              'Enable Dropshipman Chrome Extension, then click the "Add to my store" button at the bottom right corner of the product details page to add the product.'
            )}
          </li>
          <li>
            {intl.get(
              "After the products are successfully added, you can find the corresponding products in the Product List > Dropshipman > Not imported in the Dropshipman APP."
            )}
          </li>
        </ol>
      );
    } else {
      CheckGooglePluginMessage = (
        <p style={{ fontSize: 16 }}>
          {intl.get(
            "We found that you haven't installed Dropshipman Chrome Extension, which will not facilitate you to sourcing goods from 1688. Do you want to install it?"
          )}
        </p>
      );
    }

    const CheckGooglePluginModal = (
      <Modal
        open={CheckGooglePluginActive}
        onClose={() => this.handleCheckGooglePluginModal()}
        title={
          GooglePluginInstall
            ? intl.get("Sourcing From 1688")
            : intl.get("Install Dropshipman Chrome Extension")
        }
        primaryAction={
          GooglePluginInstall
            ? {
                content: intl.get("Continue"),
                onAction: () => {
                  this.jumpUrl("https://www.1688.com");
                },
              }
            : {
                content: intl.get("Install"),
                onAction: () => {
                  this.jumpUrl(
                    "https://chrome.google.com/webstore/detail/dropshipman-aliexpresscom/bobhjedlciclpchpelkgiojkmmfgnihg?"
                  );
                },
              }
        }
        secondaryActions={
          !GooglePluginInstall && [
            {
              content: intl.get("Cancel"),
              onAction: () => this.handleCheckGooglePluginModal(),
            },
          ]
        }
      >
        <Modal.Section>{CheckGooglePluginMessage}</Modal.Section>
      </Modal>
    );

    const TemuModal = (
      <Modal
        size="large"
        open={this.state.temuModal}
        onClose={()=>this.setState({
          temuModal:false
        })}
        title={intl.get("Import products from TEMU")}
      >
        <Modal.Section>
          <div className="temu_content_modal">
            <div>
           {intl.get("Importing TEMU products requires the installation of the Dropshipman Google Extension. Please follow these steps:")}
            <p> {intl.get("1. Download and install the")} <a style={{color: "#4584FE",display:'inline-flex'}} href={'https://chromewebstore.google.com/detail/dropshipman-aliexpresstem/bobhjedlciclpchpelkgiojkmmfgnihg'} target='_blank' rel="noopener noreferrer"> {intl.get("Dropshipman Google Extension.")} <img width={20} height={20} src='/share_icon.png' alt='dsmshipman'></img> </a> </p>
            <p> {intl.get("2. Log in to the Dropshipman Google Extension using your Dropshipman account.")}</p>
            <p> {intl.get("3. Visit the TEMU product details page, and click the \"Add to my product list\" button to collect the product.")} <a style={{color: "#4584FE",display:'inline-flex'}} href={'https://www.temu.com/'} target='_blank' rel="noopener noreferrer">https://www.temu.com/<img width={20} height={20} src='/share_icon.png' alt='dsmshipman'></img> </a></p>
            <p style={{textAlign:'center',marginTop:'10px'}}>
              <img style={{width:'100%'}} src='/temu/image_banner.png' alt='dsmshipman' />
            </p>
            </div>
          </div>
        </Modal.Section>
      </Modal>)
    return (
      <div>
        {/* 黑色星期五活动 */}
        {/* {blackFridayBanner} */}
        {/* { showUserPreferences && <UserProductPreferences show={showUserPreferences} callback={this.callBackCloseModal} />} */}
        {this.state.Imageload && (
          <div className={"loading_mask"}>
            <div className="full_height">
              <div className="spinner_find">
                <Spinner accessibilityLabel="Spinner example" size="large" />
              </div>
            </div>
          </div>
        )}
        {/* {this.state.Imageload && <div className='spinner_find'><Spinner accessibilityLabel="Spinner example" size="large" /></div> } */}

        {/* 页面内容 */}
        {pageContent}

        {toastMarkup}

        {!this.state.productAddSuccess && SingleOperationTipsModal}

        <div id="showTopButton">{RoundButton}</div>
        {TemuModal}
        {CouponPopModal}
        {/* 未订阅 */}
        <Suspense fallback={<div>Loading...</div>}>
          <UpgradePlanModal
            upgradeOpen={this.state.upgradeModal}
            setUpgradeOpen={() => this.setState({ upgradeModal: false })}
          />
        </Suspense>
        {/* dsm产品导入限制 */}
        <Suspense fallback={<div>Loading...</div>}>
          <ImportDsmModal
            importOpen={this.state.importantDsmModal}
            num={this.state.importantDay}
            setImportOpen={() => this.setState({ importantDsmModal: false })}
          />
        </Suspense>
        {/* 偏好选择弹窗 */}
        {CateSelectPopModal}
        {/* 谷歌插件检测弹窗 */}
        {CheckGooglePluginModal}

        {/* 1688 AliExpress导入弹窗 */}
        <ImportFormOther
          data={{
            open: this.state.otherImportParams?.open,
            type: 'AliExpress',  
            from:'find'
          }}
          onChange={()=>this.handleOtherOnChange}
        />
        <ImportAliexpressModal importOpen={this.state.aliImportModal} num={100} setImportOpen={()=>this.setAliImportModal}/>
        {/* ali产品导入限制 */}
      </div>
    );
  }
}
// const mapStateToProps = state => {
//   return {
//     subScriptData: state.languageReducer.subScriptData
//   }
// }
export default connect()(withRouter(FindProducts));
